import * as actionTypes from 'constants/actionTypes';

export const goToPage = (pageName, pageProps) => ({
    type: actionTypes.GO_TO_PAGE,
    pageName,
    pageProps
});
